import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Breadcrumbs — visible + JSON-LD-compatible.
 * items: [{ label, to }] where the last item's to is optional (current page).
 */
export function Breadcrumbs({ items = [], className = "" }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`text-sm text-ink/70 ${className}`}
      data-testid="breadcrumbs"
    >
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        <li className="flex items-center">
          <Link
            to="/"
            className="inline-flex items-center gap-1 hover:text-forest transition-colors"
            data-testid="breadcrumb-home"
          >
            <Home size={13} /> Home
          </Link>
        </li>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center">
              <ChevronRight size={13} className="text-ink/40 mx-1" aria-hidden />
              {last || !it.to ? (
                <span aria-current="page" className="text-forest font-medium">
                  {it.label}
                </span>
              ) : (
                <Link to={it.to} className="hover:text-forest transition-colors">
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

/** JSON-LD BreadcrumbList schema builder. */
export function buildBreadcrumbLd(items, origin) {
  const base = origin || (typeof window !== "undefined" ? window.location.origin : "");
  const list = [{ label: "Home", to: "/" }, ...items];
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: list.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: it.to ? `${base}${it.to}` : undefined,
    })),
  };
}
